import React from "react";

const LandscapeLoadingBannerCard: React.FC = (props): JSX.Element => {
	return <div className="h-40 sm:h-[24rem] md:h-[27rem] w-full lg:w-64 2xl:w-80 lg:h-28 2xl:h-40 animate-pulse bg-gray-300 px-4 py-6 duration-500 lg:ease-out rounded-md"></div>;
};

export default LandscapeLoadingBannerCard;
